import {DiscordContentFrameMessageData} from '../../../../../../shared/DiscordActivityTypes'
import {DiscordMountController} from '../DiscordMountController'

export class DiscordMountContentFrameListener {
    private readonly discordMountController: DiscordMountController

    constructor(discordMountController: DiscordMountController) {
        this.discordMountController = discordMountController

        this.listenForMessagesFromContentFrame()
    }

    private listenForMessagesFromContentFrame() {
        window.addEventListener('message', (messageData) => void this.handleMessageReceivedFromContentFrame(messageData))
    }

    private async handleMessageReceivedFromContentFrame({data: messageData}: MessageEvent<DiscordContentFrameMessageData>) {
        if(typeof messageData !== 'object') return
        if(Array.isArray(messageData)) return
        if(messageData === null) return

        await this.discordMountController.handleMessageReceivedFromContentFrame(messageData)
    }
}
